import { installExpoGlobalPolyfill } from 'expo-modules-core/src/polyfill/dangerous-internal';

/**
 * Webpack does not always resolve expo-modules-core's `./polyfill/index.web.ts`
 * before other modules read `globalThis.expo.NativeModule`. expo-font and
 * @expo/vector-icons extend NativeModule at import time, so install the polyfill
 * synchronously on web before any other app imports.
 *
 * No-op on native — the native runtime provides globalThis.expo before JS loads.
 */
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  installExpoGlobalPolyfill();
}
